/**
 * @generated SignedSource<<6df96d18e3e8d1f9ccb75173f1b62084>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type hooksCreateApiKeyStandardMutation$variables = {
  name: string;
};
export type hooksCreateApiKeyStandardMutation$data = {
  readonly createStandardApiKey: {
    readonly token: string;
  } | null;
};
export type hooksCreateApiKeyStandardMutation = {
  response: hooksCreateApiKeyStandardMutation$data;
  variables: hooksCreateApiKeyStandardMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      }
    ],
    "concreteType": "CreateStandardApiKey",
    "kind": "LinkedField",
    "name": "createStandardApiKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "hooksCreateApiKeyStandardMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "hooksCreateApiKeyStandardMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ce89cab7d6fdf4bcb8b2eba55b5a0e00",
    "id": null,
    "metadata": {},
    "name": "hooksCreateApiKeyStandardMutation",
    "operationKind": "mutation",
    "text": "mutation hooksCreateApiKeyStandardMutation(\n  $name: String!\n) {\n  createStandardApiKey(name: $name) {\n    token\n  }\n}\n"
  }
};
})();

(node as any).hash = "a5bd6cc7d60c005c8a5ba4104390a40b";

export default node;
